import angular from "angular";

angular
    .module('app')
    .component('courseReviewWithReply', {
        template: require('./course-review-with-reply.html'),
        controller: ['$uibModal', '$http', '$sce', '$timeout', '$interval', 'Notifier','trans', 'Language','moment', controller],
        bindings: {
            course: '<',
            review: '<',
        }
    });

function controller($uibModal, $http, $sce, $timeout, $interval, Notifier,trans, Language,moment) {

    let $ctrl = this;

    $ctrl.text = null;
    $ctrl.rating = null;
    $ctrl.l = null;

    $ctrl.$onInit = function () {


        $ctrl.lessons = [];
        $ctrl.course.chapters.forEach(function (chapter, chapterInd) {
            chapter.lessons.forEach(function (lesson, lessonInd) {
                $ctrl.lessons.push(lesson);
                lesson.pTitle = (chapterInd + 1) + '.' + (lessonInd + 1) + ' ' + lesson.title;
            });
        });


        $ctrl.text = $ctrl.review.text;
        $ctrl.rating = $ctrl.review.rating;
        $ctrl.replier = $ctrl.review.replier.full_name;

    };

    $ctrl.toggleChapter = function (chapter) {
        chapter.open = !chapter.open;
    };

    $ctrl.goToLesson = function () {
        window.location = `/cabinet/courses/${$ctrl.course.id}/?lesson_id=${$ctrl.l.id}`;
    };

}
